<div class="NgxEditor" #ngxEditor>
  <ng-content></ng-content>
</div>
